export default "__VITE_ASSET__3abf65ec__"